document.addEventListener('DOMContentLoaded', function() {
    // Select every button with the "cta-button" class that has a upsell page set
    var buttons = document.querySelectorAll('.cta-button[data-upsell-page]');
    
    buttons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        // Retrieve the upsell URL from the data attribute
        var upsellPage = button.getAttribute('data-upsell-page');
        if (upsellPage && upsellPage.trim() !== "") {
          // Prevent the default form submission
          e.preventDefault();
          // Find the closest form element
          var form = button.closest('form.add-to-cart-form');
          if (form) {
            var formData = new FormData(form);
            // Perform an AJAX POST to add the product to the cart
            fetch('/cart/add.js', {
              method: 'POST',
              body: formData,
            })
            .then(function(response) {
              if (!response.ok) {
                throw new Error('Network response was not ok');
              }
              return response.json();
            })
            .then(function(data) {
              // Redirect to upsell page after successful addition
              window.location.href = upsellPage;
            })
            .catch(function(error) {
              console.error('Error adding to cart:', error);
              // Fallback to the cart, if needed
              window.location.href = '/cart';
            });
          }
        }
        // Otherwise, let the button work normally (form submission)
      });
    });
  });